import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

export interface QuizStore {
    quiz: QuizStoreState;
    quizEditor: QuizEditorStoreState;
}

export interface QuizStoreState {
    quizzes: Quiz[];
    quizzesLoadingStatus: LOADING_STATUSES;
    quizToPreview?: Quiz;
    quizzesToDelete: Record<
        QuizId,
        {
            index: number;
            quiz: Quiz;
        }
    >;
    roomPin?: string;
    studentsMap: StudentsMap;
    statData: StatData | null;
}

export type StudentsMap = Record<StudentId, Student>;

type StudentId = string;

export interface Student {
    answers: Record<QuestionIndex, AnswerStatus>;
    id: string;
    isOnline: boolean;
    name: string;
}

type QuestionIndex = number;

export interface QuizEditorStoreState {
    quizDraft: Quiz;
    isQuizDraftStarted: boolean;
}

export interface GetQuizzesResponse {
    count: number;
    results: Quiz[];
}

export interface QuizList {
    title: string;
    quizzes: Quiz[];
    cardImgSrcSet?: Record<string, string>;
}

export type QuizId = string;

export interface Quiz {
    author?: number;
    id: QuizId;
    questions: Question[];
    subject: string | null;
    title: string;
}

export interface Question {
    title: string;
    answers: Answer[];
}

export interface Answer {
    correct: boolean;
    value: string;
}

export interface CurrentStudentAnswer {
    title: string;
    answerIndex: number;
    answerValue: string;
}

export type AnswerStatus = 'correct' | 'incorrect' | 'pending';

type AnswerIndex = number;
type StudentsCount = number;

export interface StatData {
    rightAnswerIndex: number;
    results: QuestionResults;
}

export type QuestionResults = Record<AnswerIndex, StudentsCount>;

type StudentRoomId = string;

export type StudentRooms = Record<StudentRoomId, (event: string, data?: unknown) => void>;

export interface StatItem {
    questionIndex: number;
    answerIndex: number;
    answerStatus: Omit<AnswerStatus, 'pending'>;
    studentId: number;
}

export enum CARD_COLORS {
    'blue',
    'aqua',
    'red',
    'yellow',
}
